<template>
  <VForm v-model="modelFormData" ref="Form" class="position-head">
    <IndicatorIcons v-if="indicators.length" :indicators="indicators" show-title class="mb-20" />

    <div class="d-flex mb-20" :class="{ 'flex-col ai-n gap-s': isMobile, 'ai-c gap-m': !isMobile }">
      <InfoTextBlock
        labelText="№ позиции"
        :text="modelFormData.sort ? modelFormData.sort : '-'"
      />

      <VInput
        label="Кол-во:"
        class="input--row input-text input--value"
        name="value"
        width="initial"
        input-width="75px"
        :disabled="isDisabled"
        required
        :pattern="pattern.num"
        :custom-validation="validationPositionValue"
      >
        <Validation for="required"/>
        <Validation for="pattern" key-text="num"/>
        <Validation for="customValidation">Не может быть меньше суммы пружин в партиях</Validation>
      </VInput>

      <InfoTextBlock
        labelText="Масса позиции"
        :text="weightPosition"
      />

      <InfoTextBlock
        labelText="Общий вес"
        :text="totalDirtyWeightConsignments"
      />
    </div>

    <div class="d-flex gap-m ai-c w-max-100 mb-10">
      <InfoTextBlock
        v-if="isDisabled"
        labelText="Артикул"
        :text="modelFormData.article"
      />
      <VInput
        v-else
        label="Артикул:"
        class="input--row input-text w-max-max"
        name="article"
        :disabled="isDisabled"
        required
      >
        <Validation for="required"/>
      </VInput>
      <VButton
        v-if="hasOrdersInWork"
        text="Есть др. позиции в работе"
        size="sm"
        icon="position-in-work"
        class="btn--no-shadow-always as-n"
        color="orange-dawn"
        @click.native="openModal('orders_in_work')"
      />
    </div>

    <p
      class="order-position__stock mb-20"
      :style="countMaterialByArticle ? '' : 'color: #898989'"
    >
      В наличии: <span>{{ countMaterialByArticle || 0 }}</span>
    </p>

    <VInputFiles
      class="mb-30"
      name='files'
      :is-edit="!isDisabled && !isDisabledForShipped"
      with-preview
      @onRemoveFile="SET_CURRENT_POSITION_FILES_DELETE"
    />

    <VSelect
      label="Диспетчер производства"
      name="responsible"
      :style="isMobile ? 'max-width: 425px' : 'max-width: 350px'"
      :class="{ 'mb-20': isMobile, 'mb-30': !isMobile }"
      :options="productionMasterList"
      :disabled="isDisabled || isDisabledForShipped"
      :required="isRequiredForOrderStatusChange"
    >
      <Validation for="required"/>
    </VSelect>

    <div class="position">
      <VInput
        name="name"
        label="Наименование"
        :required="isRequiredForOrderStatusChange"
        :style="isMobile ? 'max-width: 425px' : ''"
        :disabled="isDisabled || isDisabledForShipped"
      >
        <Validation for="required"/>
      </VInput>
    </div>
    <BaseModal
      v-if="isModal === 'orders_in_work'"
      title="Другие позиции в работе"
      class="modal-position-work"
      @close="closeModal"
    >
      <AppTable
        class="modal__table modal__box custom-scroll"
        :columns="orders_table_columns"
        :items="ordersTableItems"
      />
    </BaseModal>
  </VForm>
</template>

<script>
import VForm from '@/components/Form/VForm.vue'
import InfoTextBlock from '@/components/ui/AppInfoTextBlock'
import Validation from '@/components/Form/Validation'
import VInput from '@/components/Form/Vinput/VInput'
import VInputFiles from '@/components/Form/VInputFiles/VInputFiles'
import VSelect from '@/components/Form/VSelect'

import { mapGetters, mapMutations, mapState } from 'vuex'
import { formulaTotalWeight } from '@/utils/production/position/formulas'
import { fixedNumberCopy } from '@/utils/number'
import { PATTERN_LIST } from '@/const/validation'
import IndicatorIcons from '@/components/production/IndicatorIcons.vue'
import VButton from '@/components/simple/button/VButton.vue'
import AppTable from '@/components/ui/AppTable.vue'
import BaseModal from '@/components/ui/Modal/BaseModal.vue'
import { createColOrderLinks } from '@/const/table/columns'
import { mixinModal } from '@/mixins/modal/mixinModal'

export default {
  name: 'PositionHeadForm',
  components: {
    BaseModal,
    AppTable,
    VButton,
    IndicatorIcons,
    VForm,
    InfoTextBlock,
    Validation,
    VInput,
    VInputFiles,
    VSelect
  },
  mixins: [mixinModal],
  props: {
    isDisabled: {
      type: Boolean
    },
    indicators: {
      type: Array
    },
    orderStatusId: {
      type: Number,
      required: false
    },
    isDisabledForShipped: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    pattern: PATTERN_LIST,
    orders_table_columns: [
      {
        title: 'Номер заказа',
        name: 'orders',
        ...createColOrderLinks()
      },
      {
        title: 'Тип заказа',
        name: 'type'
      }
    ]
  }),

  computed: {
    ...mapGetters('orderDetail', {
      currentPosition: 'currentPosition',
      totalDirtyWeightConsignments: 'totalDirtyWeightConsignments',
      positionConsignmentsLength: 'positionConsignmentsLength',
      positionConsignments: 'positionConsignments'
    }),
    ...mapGetters({
      productionMasterList: 'users/productionMasterList',
      countMaterialByArticle: 'warehouse/countMaterialByArticle'
    }),
    ...mapState('mobile', {
      isMobile: 'isMobile'
    }),

    modelFormData: {
      get () {
        return this.currentPosition
      },
      set (newFormData) {
        this.SET_CURRENT_POSITION_VALUE({ value: newFormData })
      }
    },

    positionConsignmentsCount () {
        let isValue = false
        this.positionConsignments.forEach(item => {
            if (item.value !== 0) isValue = true
        })
        return isValue
    },

    calcTotalWeight () {
      return formulaTotalWeight(this.modelFormData)
    },

    weightPosition () {
      let weightTotal = this.calcTotalWeight ? this.calcTotalWeight * this.modelFormData.value : 0
      if (weightTotal !== 0) {
        weightTotal = fixedNumberCopy(weightTotal, 2)
      }
      return weightTotal
    },

    isRequiredForOrderStatusChange () {
      if (this.orderStatusId && this.orderStatusId === 1) return false
      else return true
    },
    hasOrdersInWork () {
      return this.currentPosition?.orders_in_work_by_article?.length > 0
    },

    ordersTableItems () {
      if (!this.hasOrdersInWork) return []

      const result = Object.values(
        this.currentPosition?.orders_in_work_by_article?.reduce((acc, item) => {
          if (!acc[item.type]) {
            acc[item.type] = {
              type: item.type,
              orders: []
            }
          }

          acc[item.type].orders.push({
            id: item.id,
            account_number: item.account_number
          })

          return acc
        }, {})
      )

      return result
    }
  },

  methods: {
    ...mapMutations('orderDetail', [
      'SET_CURRENT_POSITION_VALUE',
      'SET_CURRENT_POSITION_FILES_DELETE'
    ]),

    validationPositionValue (value) {
      const consignments = this.modelFormData.consignments
      if (!consignments?.length) return true

      const consignmentsValue = consignments.reduce((prev, current) => {
        return prev + current.value
      }, 0)

      return +value >= consignmentsValue
    }
  }
}
</script>
